/**
  * This file is auto-generated. Do not modify this file manually.
  */
export const errors = [
  {
    "id": "unknown-error",
    "title": "Unknown Error (MAIN_MOD_ERROR)"
  },
  {
    "id": "unauthorized",
    "title": "Unauthorized Error (UNAUTHORIZED)"
  },
  {
    "id": "system-configuration-error",
    "title": "System Configuration Error (SYSTEM_CONFIGURATION_ERROR)"
  },
  {
    "id": "settings-to-dev-portal-migration",
    "title": "Settings to Dev Portal Migrations"
  },
  {
    "id": "schema-validation-failed",
    "title": "Schema Validation Failed (SCHEMA_VALIDATION_FAILED)"
  },
  {
    "id": "not-found",
    "title": "Not Found Error (NOT_FOUND)"
  },
  {
    "id": "no-project-set",
    "title": "No Project Set Error (NO_PROJECT_SET)"
  },
  {
    "id": "main-mod-error",
    "title": "Zuplo Main Module Error (MAIN_MOD_ERROR)"
  },
  {
    "id": "invalid-settings-dev-portal-auth",
    "title": "Invalid Settings - Dev Portal Auth (INVALID_SETTINGS_DEV_PORTAL_AUTH)"
  },
  {
    "id": "invalid-settings-dev-portal-auth-audience",
    "title": "Invalid Settings - Dev Portal Auth Audience (INVALID_SETTINGS_DEV_PORTAL_AUTH_AUDIENCE)"
  },
  {
    "id": "get-head-body-error",
    "title": "GET/HEAD Body Error (GET_HEAD_BODY_ERROR)"
  },
  {
    "id": "fatal-project-error",
    "title": "Zuplo Fatal Project Error (FATAL_PROJECT_ERROR)"
  },
  {
    "id": "build-error",
    "title": "Build Error (BUILD_ERROR)"
  },
  {
    "id": "bad-request",
    "title": "Bad Request (BAD_REQUEST)"
  }
];